import { providerSchema, providersSchema } from "./schema";
import { getEntity, getEntities, getEntityIds } from "./base";

const path = "/portal/api/providers";

const getProvider = (clientConfig, entityId) => {
  return getEntity(clientConfig, entityId, path, providerSchema);
};

const getProviderIds = (clientConfig, offerType, dataStatus) => {
  return getEntityIds(
    clientConfig,
    dataStatus,
    path,
    offerType,
    clientConfig.limits
  );
};

const getProviders = (clientConfig, dataStatus) => {
  let limits = { ...clientConfig.limits };
  limits.brandId = [];
  limits.phoneId = [];
  limits.phoneOperatingSystemId = [];
  limits.phoneVariantId = [];

  return getEntities(
    clientConfig,
    dataStatus,
    path,
    providersSchema,
    {},
    limits
  );
};

export { getProvider, getProviderIds, getProviders };
